// Shared constants for the AI Intelligence module. Kept in one place so pages,
// the sidebar and routes stay consistent.

// Route names (must be globally unique across the app — prefixed with ai_intelligence_).
export const AI_ROUTES = {
  index: 'ai_intelligence_index',
  overview: 'ai_intelligence_overview',
  salesPerformance: 'ai_intelligence_sales_performance',
  clients: 'ai_intelligence_clients',
  products: 'ai_intelligence_products',
  opportunities: 'ai_intelligence_opportunities',
  actionDemo: 'ai_intelligence_action_demo',
  targets: 'ai_intelligence_targets',
};

// Date-range presets — these mirror the Commercial Intelligence server presets,
// which resolve against the latest commercial data date (NOT today). Sending the
// preset keeps Chatwoot and the CI dashboard perfectly aligned.
export const DATE_PRESETS = [
  { value: 'auto', labelKey: 'AI_INTELLIGENCE.DATE_RANGE.PRESETS.AUTO' },
  {
    value: 'last_90_days',
    labelKey: 'AI_INTELLIGENCE.DATE_RANGE.PRESETS.LAST_90_DAYS',
  },
  {
    value: 'last_6_months',
    labelKey: 'AI_INTELLIGENCE.DATE_RANGE.PRESETS.LAST_6_MONTHS',
  },
  {
    value: 'last_12_months',
    labelKey: 'AI_INTELLIGENCE.DATE_RANGE.PRESETS.LAST_12_MONTHS',
  },
  { value: 'all', labelKey: 'AI_INTELLIGENCE.DATE_RANGE.PRESETS.ALL' },
  { value: 'custom', labelKey: 'AI_INTELLIGENCE.DATE_RANGE.PRESETS.CUSTOM' },
];

export const DEFAULT_DATE_PRESET = 'auto';

// Ranking metric options shared by Overview / Sales Performance / Products.
export const METRIC_OPTIONS = [
  { value: 'value', labelKey: 'AI_INTELLIGENCE.METRIC.VALUE' },
  { value: 'quantity', labelKey: 'AI_INTELLIGENCE.METRIC.QUANTITY' },
];

// Opportunity Center tabs. 'all' plus the four opportunity types. reorder/winback
// are always available; crosssell/upsell appear only when the server reports > 0
// (available_types), so pages filter these against the payload.
export const OPPORTUNITY_TYPES = [
  { value: 'all', labelKey: 'AI_INTELLIGENCE.OPPORTUNITIES.TYPES.ALL' },
  { value: 'reorder', labelKey: 'AI_INTELLIGENCE.OPPORTUNITIES.TYPES.REORDER' },
  { value: 'winback', labelKey: 'AI_INTELLIGENCE.OPPORTUNITIES.TYPES.WINBACK' },
  {
    value: 'crosssell',
    labelKey: 'AI_INTELLIGENCE.OPPORTUNITIES.TYPES.CROSSSELL',
  },
  { value: 'upsell', labelKey: 'AI_INTELLIGENCE.OPPORTUNITIES.TYPES.UPSELL' },
];

// Maps a CI opportunity priority to a design-system Label color.
export const PRIORITY_COLOR = {
  urgent: 'ruby',
  important: 'amber',
  good: 'teal',
};

// Maps a CI target status to a design-system Label color.
export const TARGET_STATUS_COLOR = {
  Achieved: 'teal',
  'On track': 'blue',
  'In progress': 'amber',
  'Not started': 'slate',
  'Past due': 'ruby',
  'Waiting for sales data': 'slate',
};

// Dismiss reason codes — must match the server's DISMISS_REASONS validation.
export const DISMISS_REASONS = [
  { value: 'customer_not_interested', label: 'Customer not interested' },
  {
    value: 'customer_does_not_use_product',
    label: 'Customer does not use product',
  },
  { value: 'already_has_equivalent', label: 'Already has an equivalent' },
  { value: 'wrong_product_fit', label: 'Wrong product fit' },
  { value: 'price_too_high', label: 'Price too high' },
  { value: 'temporary_timing_issue', label: 'Temporary timing issue' },
  { value: 'data_incorrect', label: 'Data incorrect' },
  { value: 'other', label: 'Other' },
];

// Maps a demo result status to a design-system Label color.
export const DEMO_RESULT_COLOR = {
  pending: 'slate',
  successful: 'teal',
  partial: 'amber',
  unsuccessful: 'ruby',
  dismissed: 'slate',
};

// Target types for the Targets page create/edit form.
export const TARGET_TYPES = [
  { value: 'revenue', labelKey: 'AI_INTELLIGENCE.TARGETS.TYPE.REVENUE' },
  { value: 'quotes', labelKey: 'AI_INTELLIGENCE.TARGETS.TYPE.QUOTES' },
  {
    value: 'new_clients',
    labelKey: 'AI_INTELLIGENCE.TARGETS.TYPE.NEW_CLIENTS',
  },
  {
    value: 'conversion_rate',
    labelKey: 'AI_INTELLIGENCE.TARGETS.TYPE.CONVERSION_RATE',
  },
];
